import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { StateManager } from '@/state/stateManager';
import { BaseSmartComponent } from '@/components/base.component';
import { MessageService } from '@/services/message.service';
import * as routerUtils from '@/utils/routerUtils';
import { CustomerService } from '@/services/customer.service';
import { IContactModel, ContactModel } from '@/models/contact.models';
import { handleError } from '@/utils/errors';

@Component({
  selector: 'customer-contact-list',
  templateUrl: './customerContactList.template.html',
  host: {'class': 'customer-contact-list-component'}
})
export class CustomerContactListComponent extends BaseSmartComponent implements OnInit {
  public model: Observable<Array<IContactModel>>;

  private _id: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private state: StateManager,
    messageService: MessageService,
    private customerService: CustomerService
  ) {
    super(messageService);
  }

  ngOnInit(): void {
    this.model = this.state.getContactsList();
    this._id = routerUtils.getRouteParameter(this.route, 'customerId');
    this.customerService.getContacts(this._id);
  }

  addContact(): void {
    this.state.setActiveContact(new ContactModel());
    this.router.navigate(['Add'], { relativeTo: this.route });
  }

  editContact(contact: IContactModel): void {
    this.router.navigate([contact._id], { relativeTo: this.route });
  }

  deleteContact(contact: IContactModel): void {
    this.customerService.deleteContact(this._id, contact._id)
      .then(() => this.customerService.getContacts(this._id))
      .catch(handleError);
  }

  toggleContactStatus(contact: IContactModel): void {
    this.customerService.updateContact(this._id, contact)
      .then(() => {console.info("Contact status updated")})
      .catch(handleError);
  }
}
